'use client';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import sprite from '@lualtek/icons/sprite';
import clsx from 'clsx';
import { Children, cloneElement, forwardRef, useMemo, } from 'react';
import styles from './icon.module.css';
export const Icon = forwardRef(({ className, source, dimension = 18, fill, ...otherProps }, forwardedRef) => {
    const dynamicStyle = useMemo(() => (Number(dimension) < 18 ? 'solid' : 'duotone'), [dimension]);
    return (typeof source === 'string')
        ? (_jsx("svg", { "aria-hidden": "true", width: dimension, height: dimension, fill: fill, className: clsx(styles.Icon, className), ref: forwardedRef, ...otherProps, children: _jsx("use", { href: `${sprite}#${dynamicStyle}/${source}` }) }))
        : (_jsx(_Fragment, { children: Children.map(source, (child) => cloneElement(child, {
                className,
                'aria-hidden': 'true',
                width: dimension,
                height: dimension,
            })) }));
});
